import { Divider, Grid, Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { StyledComponentProps } from "@mui/styles";
import AuthService from "api/Auth";
import { HeaderStylesClassKey } from "assets/jss/layouts/headerLinksStyle";
import AppResource from "components/Translations/AppResources";
import { AccessKeys } from "Constants";
import AboutDialog from "layouts/Components/AboutDialog";
import HtmlUtils from "lib/HtmlUtils";
import { Cultures } from "models/AppModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from 'react-router-dom';
import { RoutePaths } from "routes/RouteConfig";
import Session, { DefaultCulture } from "services/Session";
import ChangePasswordDialog from "views/User/Dialogs/ChangePasswordDialog";
import HeaderLinkButton from "./HeaderLinkButton";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    lastUpdate: number;
    open: boolean;
    dlg: any;
    achorEl: any;
}

type Props = RouteComponentProps & WithTranslation & StyledComponentProps<HeaderStylesClassKey>;

/////////////////////////////////////////////////////////////////////////////////////////////////

class HeaderUserMenu extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            lastUpdate: null,
            open: false,
            dlg: null,
            achorEl: null
        };
    }

    ///
    private handleToggle() {
        this.setState(state => ({ open: !this.state.open }));
    }

    ///
    private handleClose() {
        this.setState({ open: false });
    }

    ///
    private handleAction(action: string) {

        switch (action) {
            case "about": {
                this.setState({
                    dlg: (
                        <AboutDialog
                            onClose={() => { this.setState({ dlg: null }); }}
                        />
                    )
                });
                break;
            }

            case "logout": {
                AuthService.signOut();
                this.props.history.replace(RoutePaths.Login);
                break;
            }

            case "logoutAll": {
                AuthService.signOut(true);
                this.props.history.replace(RoutePaths.Login);
                break;
            }

            case "view": {
                HtmlUtils.openUrlInNewWindow(RoutePaths.UserProfileViewer.replace(":id?", ""), "userprofile");
                break;
            }

            case "edit": {
                this.props.history.push(RoutePaths.EditUserAccount);
                break;
            }

            case "changePassword": {
                this.setState({
                    dlg: (
                        <ChangePasswordDialog
                            userId={Session.user.id}
                            requiresOldPassword
                            onClose={() => { this.setState({ dlg: null }); }}
                        />
                    )
                });
                break;
            }
        }

        this.setState({ open: false });
    }

    ///
    private changeImage = () => {
        this.setState({ lastUpdate: Session.user.lastUpdate });
    };

    ///
    private handleLang(lng: string) {
        Session.uiCulture = lng;
        this.setState({ achorEl: null, open: false });
    }

    ///
    private buildLangMenu() {
        const flag = Cultures.find(p => p.cultures.indexOf(Session.uiCulture) > -1) || Cultures.find(p => p.cultures.indexOf(DefaultCulture) > -1);
        const { classes } = this.props;

        // Provisório: remover quando os idiomas forem restaurados.
        return null;

        return (
            <MenuItem key="mLang" disableGutters  >
                <MenuList key="mLangMenu" role="menu" disablePadding style={{ width: "100%" }} >
                    <MenuItem
                        className={classes.menuItem}
                        style={{ display: "flex", justifyContent: "space-between" }}
                        onClick={
                            (e) => {
                                this.setState({ achorEl: e.currentTarget });
                            }
                        }
                    >
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item><img src={`/img/flags/${flag.flag}.png`} width={16} height={16} alt={flag.name} /></Grid>
                            <Grid item>{flag.name}</Grid>
                        </Grid>
                    </MenuItem>

                    {
                        Cultures.length > 1 &&
                        <Menu
                            anchorOrigin={
                                {
                                    vertical: "top",
                                    horizontal: "left"
                                }
                            }
                            transformOrigin={
                                {
                                    vertical: "top",
                                    horizontal: "right"
                                }
                            }
                            open={this.state.achorEl != null}
                            anchorEl={this.state.achorEl}
                            onClose={() => this.setState({ achorEl: null })}
                        >
                            {
                                Cultures
                                    .filter(p => p.flag != flag.flag)
                                    .map((v, index) => (
                                        <MenuItem
                                            key={index}
                                            className={classes.menuItem}
                                            onClick={(e) => this.handleLang(v.cultures[0])}
                                        >
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item><img src={`/img/flags/${v.flag}.png`} width={16} height={16} alt={v.name} /></Grid>
                                                <Grid item>{v.name}</Grid>
                                            </Grid>
                                        </MenuItem>
                                    ))
                            }
                        </Menu>
                    }
                </MenuList>
            </MenuItem>
        );
    }

    ///
    public componentDidMount() {
        Session.subscribe(this.changeImage);
    }

    ///
    public componentWillUnmount() {
        Session.unsubscribe(this.changeImage);
    }

    ///
    public render() {
        const { classes } = this.props;
        const { name } = Session.user;
        const langMenu = this.buildLangMenu();

        const ml = [];
        ml.push(<MenuItem key="m1" onClick={(e) => this.handleAction("view")} className={classes.menuItem} > <AppResource resource="Common.Menu.User.ViewProfile" /></MenuItem>);
        ml.push(<MenuItem key="m2" onClick={(e) => this.handleAction("edit")} className={classes.menuItem}><AppResource resource="Common.Menu.User.EditProfile" /></MenuItem>);
        if (Session.isLocalAccount) {
            ml.push(<MenuItem key="m4" onClick={(e) => this.handleAction("changePassword")} className={classes.menuItem}><AppResource resource="Common.Menu.User.ChangePassword" />...</MenuItem>);
        }
        ml.push(<Divider key="div1" />);

        if (langMenu) {
            ml.push(langMenu);
            ml.push(<Divider key="div2" />);
        }

        ml.push(<MenuItem key="m7" onClick={(e) => this.handleAction("about")} className={classes.menuItem}><AppResource resource="Common.Menu.User.About" />...</MenuItem>);
        ml.push(<Divider key="div3" />);

        ml.push(<MenuItem key="m8" onClick={(e) => this.handleAction("logout")} className={classes.menuItem}><AppResource resource="Common.Menu.User.Logout" /></MenuItem>);
        if (Session.logoutOptions.samlLogoutUrl != null) {
            ml.push(<MenuItem key="m9" onClick={(e) => this.handleAction("logoutAll")} className={classes.menuItem}><AppResource resource="Common.Menu.User.LogoutAll" /></MenuItem>);
        }

        return (
            <>
                {this.state.dlg}
                <HeaderLinkButton
                    accessKey={AccessKeys.UserMenu}
                    classes={classes}
                    icon={Session.thumbnailUrl}
                    tooltip={name}
                    open={this.state.open}
                    handleClose={() => this.handleClose()}
                    handleToggle={() => this.handleToggle()}
                >
                    <MenuList role="menu">
                        {ml}
                    </MenuList>
                </HeaderLinkButton>
            </>
        );
    }
}

export default withTranslation()(HeaderUserMenu);